import { AxiosResponse, AxiosError } from 'axios';
import { authHeader } from 'services';
import { IVoucher } from 'types/Voucher';

import { Api } from './api/axios.service';

const listAllVoucher = async (
  page: number,
  amount: number,
  filter: string,
  active: boolean
): Promise<any> => {
  try {
    const { data }: AxiosResponse = await Api.get(
      `/ticket?page=${page}&amount=${amount}&filter=${filter}`,
      {
        headers: authHeader(),
      }
    );
    return data;
  } catch (error) {
    const { response } = error as AxiosError;
    throw new Error(
      response?.data?.error || 'Não foi possível obter os cupons'
    );
  }
};

const getVoucherMaxPage = async (amount: number, filter: string, active: boolean): Promise<any> => {
  try {
    const { data }: AxiosResponse = await Api.get(`ticket?amount=${amount}&filter=${filter}`,
     {
       headers: authHeader(),
     });
  return data.totalPages;
  } catch (error) {
    const { response } = error as AxiosError;
    throw new Error(
      response?.data?.error || 'Não foi possível obter o número de páginas'
    )
  }
}

const createVoucher = (voucher: IVoucher) => {
  try {
    return Api.post('/ticket', voucher, {
      headers: authHeader(),
    }).then((response) => response.data);
  } catch (error) {
    const { response } = error as AxiosError;
    throw new Error(
      response?.data?.error || 'Não foi possível cadastrar os cupons'
    );
  }
};

const updateVoucher = (voucher: IVoucher, name: string) => {
  try {
    return Api.put(`/ticket/${name}`, voucher, {
      headers: authHeader(),
    }).then((response) => response);
  } catch (error) {
    const { response } = error as AxiosError;
    throw new Error(
      response?.data?.error || 'Não foi possível editar o cupom'
    );
  }
};

export const VoucherService = {
  listAllVoucher,
  createVoucher,
  updateVoucher,
  getVoucherMaxPage,
};

